import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@design-system/box';
import { useBreakpoint } from '@design-system/theme';
import { styled } from 'styled-components';
import { Col } from './Col';
import { Row } from './Row';
import { bgColors } from '../constants';
import { useGridContext } from '../contexts/GridContext';
export const GridHelper = () => {
    const { colGap, numCols } = useGridContext();
    const breakpoint = useBreakpoint();
    const color = bgColors[breakpoint];
    return (_jsx(WrapperGridHelper, { "data-testid": "grid-helper", children: _jsx(Row, { "data-testid": "grid-helper-row", children: Array.from({ length: Number(numCols) }).map((_, index) => (_jsx(Col, { "data-testid": "grid-helper-col", children: _jsx(Display, { "$colGap": colGap, "$color": color, "$isFirst": index === 0, "data-testid": "grid-helper-display" }) }, index))) }) }));
};
const WrapperGridHelper = styled.div `
  bottom: 0;
  left: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  height: 100%;
`;
const Display = styled(Box).attrs(({ $colGap, $color, $isFirst }) => ({
    display: 'block',
    height: '100%',
    backgroundColor: $colGap === 0 ? undefined : $color,
    borderLeft: $isFirst && `3px solid ${$color}`,
    borderRight: `3px solid ${$color}`,
})) ``;
//# sourceMappingURL=GridHelper.js.map